import gql from 'graphql-tag';
import { capitalize } from '../../util/strings';

const createTableQuery = (queryName, fragment, dataObject, isFilterable, isSortable, isDateRange) => {
    const capitalizedQueryName = capitalize(queryName);

    const filterByInput = isFilterable ? `$filterBy: [Filters]` : '';
    const filtersInput = isFilterable ? `$filters: [Filters]` : '';
    const sortByInput = isSortable ? `$sortBy: [SortField]` : '';
    const datesInput = isDateRange ? `$beginDate: String!, $untilDate: String!` : '';

    const filterByInputVar = isFilterable ? `filterBy: $filterBy` : '';
    const filtersInputVar = isFilterable ? `filters: $filters` : '';
    const sortByInputVar = isSortable ? `sortBy: $sortBy` : '';
    const datesInputVar = isDateRange ? `fromDate: $beginDate, toDate: $untilDate` : '';

    const sortDirection = isSortable ? 'SortDirection: ' + getTypeQuery(`${dataObject}SortFields`) : '';
    const filterOptions = isFilterable ? 'FilterOptions: ' + getTypeQuery(`${dataObject}FilterFields`) : '';
    const customFilters = isFilterable ? 'CustomFilters: ' + getTypeQuery(`${dataObject}CustomFilters`) : '';

    const sortByInfo =
        1 === 2 && isSortable
            ? `sortByInfo {
    					field
    					direction
    				}`
            : '';
    const filterByInfo =
        1 === 2 && isFilterable
            ? `filterByInfo {
    					field
    					value
    				}`
            : '';

    return gql`
        ${fragment}
        query ${capitalizedQueryName}(
            $limit: Int
            $offset: Int
            $contains: String
            ${filtersInput}
            ${filterByInput}
            ${sortByInput}
            ${datesInput}
        ){
            ${queryName}(
                limit: $limit
                offset: $offset
                contains: $contains
                ${filtersInputVar}
                ${filterByInputVar}
                ${sortByInputVar}
                ${datesInputVar}
            ){
                edges {
                    node {
                        ID
                        ...${fragment.definitions[0].name.value}
                    }
                }
                pageInfo {
                    hasNextPage
                    hasPreviousPage
                    totalCount
                }
                ${filterByInfo}
                ${sortByInfo}
            }
            ${sortDirection}
            ${filterOptions}
            ${customFilters}
        }
    `;
};

const getTypeQuery = typeName => {
    return `
		__type(name:"${typeName}"){
			name
			kind
			inputFields {
				name
				description
				type {
					name
					inputFields {
                        name
                        type {
                            name
                        }
					}
					enumValues {
                        name
					    description
                    }
				}
			}
		}`;
};
export default createTableQuery;
